import { later } from '@ember/runloop';
export function focus(input) {
  if (!input) {
    return;
  }
  setInputTabIndex(input, '-1');
  later(() => input.focus());
  setInputTabIndex(input, '0');
}
export function focusCodeInput(input) {
  if (!input) {
    return;
  }
  setTimeout(() => {
    input.setFocus();
  }, 50);
}
export function updateError(input, id) {
  if (!input) {
    return;
  }
  if (id === undefined) {
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedBy');
  } else {
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedBy', id);
  }
}
export function setInputId(input, value) {
  if (!input) {
    return;
  }
  input.setAttribute('id', value);
}
export function setInputTabIndex(input, value) {
  if (!input) {
    return;
  }
  input.setAttribute('tabindex', value);
}
export function setInputAutocomplete(input, value) {
  if (!input) {
    return;
  }
  input.setAttribute('autocomplete', value);
}
export function setInputPattern(input, value) {
  if (!input) {
    return;
  }
  input.setAttribute('pattern', value);
}
export function setInputInputmode(input, value) {
  if (!input) {
    return;
  }
  input.setAttribute('inputmode', value);
}
export function setInputName(input, value) {
  if (!input) {
    return;
  }
  input.setAttribute('name', value);
}
export function setInputEnterListener(input, callback) {
  if (!input) {
    return;
  }
  input.addEventListener('keydown', ({
    key
  }) => key === 'Enter' ? callback() : undefined);
}
export function setInputEnterKeyHint(input, value) {
  if (!input) {
    return;
  }
  input.setAttribute('enterKeyHint', value);
}